module.exports = __webpack_public_path__ + "img/usen_group_inv.75cd9c1b.png";